import React from 'react';
import styles from './HtmlEditor.module.css';
const HtmlView = ({ value, height, onFocusIn }) => {
    return (
        <div className={styles.htmlView} onClick={onFocusIn}>
            {/* <HtmlEditor
                height={height ?? window.innerHeight - 150}
                value={value}
                onFocusIn={onFocusIn}
            >
            </HtmlEditor> */}
            <div dangerouslySetInnerHTML={{ __html: value }} />
        </div>
    );
};

export default HtmlView;